import { render } from "./EditMainNews.vue?vue&type=template&id=8b7eb250&scoped=true"
import script from "./EditMainNews.vue?vue&type=script&lang=js"
export * from "./EditMainNews.vue?vue&type=script&lang=js"

import "./EditMainNews.vue?vue&type=style&index=0&id=8b7eb250&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b7eb250"]])

export default __exports__